const actions = {
  SET_STATE: 'sport/SET_STATE',
  REFRESH_ERRORS: 'sport/REFRESH_ERRORS',
  ALL: 'sport/ALL'
};

export default actions
